import type { ContentfulImageSchema } from '@ecomm/contentful-components'
import { ContentfulImage } from '@ecomm/contentful-components'
import classNames from 'classnames'
type IllustrationProps = {
  readonly image: ContentfulImageSchema
  readonly className?: string
}

export function Illustration({ image, className }: IllustrationProps) {
  return (
    <div
      className={classNames(
        'relative mt-2 w-full max-w-3xl text-center',
        className
      )}
      data-component="Illustration"
    >
      {image && (
        <ContentfulImage className="w-full object-contain" {...image} />
      )}
    </div>
  )
}
